export default {
  items: [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "icon-graph",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Audience",
      url: "/users",
      icon: "icon-people",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Content Conversion",
      url: "/content-conversion",
      icon: "icon-conversion",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Groups",
      url: "/groups",
      icon: "icon-puzzle",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Plans & Pricing",
      url: "/plans",
      icon: "icon-docs",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Tickets & Events",
      url: "/tievents",
      icon: "icon-calendar",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Invite Codes",
      url: "/invites",
      icon: "icon-paper-plane",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Promo Codes",
      url: "/promos",
      icon: "icon-shuffle",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Content",
      url: "/content",
      icon: "icon-book-open",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Transactions",
      url: "/transactions",
      icon: "icon-tag",
      badge: {
        variant: "primary"
      }
    },
    // {
    //   name: "Resources",
    //   url: "/resources",
    //   icon: "icon-share",
    //   badge: {
    //     variant: "primary"
    //   }
    // },
    {
      name: "Automations",
      url: "/actions",
      icon: "icon-automation",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "E-mail Templates",
      url: "/emails",
      icon: "icon-note",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Popup Templates",
      url: "/templates",
      icon: "icon-docs",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Triggers",
      url: "/triggers",
      icon: "icon-feed",
      badge: {
        variant: "primary"
      }
    },
    {
      name: "Billing",
      url: "/billing-info",
      icon: "icon-wallet",
      badge: {
        variant: "primary"
      }
    },
  ]
}
